import { makeAutoObservable } from 'mobx';

import { addWidgetExistsValidation, ModelValidator } from 'framework/mobx-integration';
import { ExportWidgetConfig } from 'controls/designer/features/widgets/export/types';
import { i18n } from './localization';

export type ExportWidgetStoreProps = {
	config: ExportWidgetConfig;
	setValidator?: (formValidator: ModelValidator<ExportWidgetConfig>) => void;
	disableCreation?: boolean;
};

export class ExportWidgetStore {
	model: ExportWidgetConfig;
	validator: ModelValidator<ExportWidgetConfig>;
	widgetExists = false;

	constructor(props: ExportWidgetStoreProps) {
		this.model = props.config;
		this.widgetExists = props.disableCreation;

		this.validator = new ModelValidator(this.model);
		addWidgetExistsValidation(this.validator, () => this.widgetExists, i18n('Widget already exists on dashboard'));
		props.setValidator?.(this.validator);

		makeAutoObservable(this);
	}
}
